import { useReactiveVar } from "@apollo/client";
import { currentConfigVar } from "apollo/cache/config";
import moment from "moment";
import numeral from "numeral";
import { FC } from "react";

interface MeterShipmentViewProps {
  meterShipment: {
    status: string;
    meta: any;
    brand: any;
    model: any;
    startSerialNumber: string;
    quantity: number;
    endSerialNumber: string;
    serialNumbers: string[];
    _id: string;
    code: string;
    description: string;
    createdBy: {
      _id: string;
      code: string;
      lastName: string;
      firstName: string;
      profileImageUrl: string;
      phoneNumber: string;
      emailAddress: string;
    };
    createdAt: string;
    updatedAt: string;
  };
}

const MeterShipmentView: FC<MeterShipmentViewProps> = ({ meterShipment }) => {
  const { dateFormat } = useReactiveVar(currentConfigVar);

  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div className="p-6">
        <div className="">
          <span className="text-xs font-light">Shipment Information</span>
          <div className="grid grid-cols-3 gap-6 mt-2">
            <div>
              <span className="block text-sm font-light text-gray-700">
                Code
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {meterShipment?.code || "N/A"}
              </div>
            </div>
            <div className="col-span-2">
              <span className="block text-sm font-light text-gray-700">
                Description
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {meterShipment?.description || "N/A"}
              </div>
            </div>
            <div>
              <span className="block text-sm font-light text-gray-700">
                Created At
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {moment(meterShipment?.createdAt).format(
                  dateFormat + ", hh:mm A"
                )}
              </div>
            </div>
            <div className="col-span-2">
              <span className="block text-sm font-light text-gray-700">
                Created By
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {[
                  (meterShipment?.createdBy?.lastName || "")?.trim(),
                  (meterShipment?.createdBy?.firstName || "")?.trim(),
                ]
                  .join(" ")
                  .trim() || "N A"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="">
          <span className="text-xs font-light">Meters Information</span>
          <div className="grid grid-cols-3 gap-6 mt-2">
            <div>
              <span className="block text-sm font-light text-gray-700">
                Brand
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {meterShipment?.brand?.code} - {meterShipment?.brand?.name}
              </div>
            </div>
            <div>
              <span className="block text-sm font-light text-gray-700">
                Model
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {meterShipment?.model?.code} - {meterShipment?.model?.name}
              </div>
            </div>

            <div className="col-start-1">
              <span className="block text-sm font-light text-gray-700">
                Start Serial Number
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {meterShipment?.startSerialNumber || "N/A"}
              </div>
            </div>
            <div>
              <span className="block text-sm font-light text-gray-700">
                End Serial Number
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {meterShipment?.endSerialNumber || "N/A"}
              </div>
            </div>
            <div>
              <span className="block text-sm font-light text-gray-700">
                Status
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {meterShipment?.status || "N/A"}
              </div>
            </div>
            <div className="col-start-1">
              <span className="block text-sm font-light text-gray-700">
                Total Meters
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {numeral(meterShipment?.meta?.totalShipments).format("0,0") ||
                  "N/A"}{" "}
                Meters
              </div>
            </div>
            <div className="">
              <span className="block text-sm font-light text-gray-700">
                Total Successful
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {numeral(meterShipment?.meta?.totalSuccessShipments).format(
                  "0,0"
                ) || "N/A"}{" "}
                Meters
              </div>
            </div>
            <div className="">
              <span className="block text-sm font-light text-gray-700">
                Total Failed
              </span>
              <div className="mt-1 block w-full sm:text-sm">
                {numeral(meterShipment?.meta?.totalFailedShipments).format(
                  "0,0"
                ) || "N/A"}{" "}
                Meters
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeterShipmentView;
